import { apiClient } from './client.js';

export const planApi = {
  /**
   * Gói hội viên cho bảng giá. kind: 'tool' = gói mua lẻ công cụ, 'all' = tất cả (trang quản trị)
   */
  getAllPlans: (kind) => {
    return apiClient.get('/plans', { params: kind ? { kind } : undefined });
  },
};
